var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { routes } from '@/router/routes';
import { AuthService } from '@/services/auth-service';
import { lazyInject } from '@/dependency-injection';
import { TYPES } from '@/dependency-injection/types';
import LayoutMixin from '@/mixins/layout-mixin';
var TheSidebar = /** @class */ (function (_super) {
    __extends(TheSidebar, _super);
    function TheSidebar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchTerm = '';
        _this.menuItems = [];
        _this.configurationMenuItems = [];
        _this.routes = routes;
        _this.authorizedMenuItems = [];
        _this.authorizedConfigurationMenuItems = [];
        /**
         * Visibility of sidebar from props or from user interaction
         */
        _this.internalVisible = false;
        return _this;
    }
    /**
     * Event emitted when the sidesheet visibility is changed by user interaction
     */
    TheSidebar.prototype.updateInternalVisible = function (val) {
        this.internalVisible = val;
        if (val) {
            this.handleSidesheetOpened();
        }
        else {
            this.handleSidesheetClosed();
        }
    };
    /**
     * Watch for sidesheet visibility changed by state interaction
     */
    TheSidebar.prototype.onSideNavigationVisibleChanged = function (val, oldVal) {
        // set the internal value when external prop changed
        this.internalVisible = val;
        if (val !== oldVal) {
            if (val) {
                this.handleSidesheetOpened();
            }
            else {
                this.handleSidesheetClosed();
            }
        }
    };
    TheSidebar.prototype.handleSidesheetOpened = function () {
        var _this = this;
        // sort routes
        this.routes = this.routes.sort(function (item1, item2) {
            var item1Name = item1.name.toUpperCase();
            var item2Name = item2.name.toUpperCase();
            if (item1Name === item2Name) {
                return 0;
            }
            else {
                return item1Name < item2Name ? -1 : 1;
            }
        });
        // normal menu items
        this.authorizedMenuItems = this.routes.filter(function (item) {
            return (item.meta &&
                item.meta.includeInMenu &&
                !item.meta.settings &&
                item.meta.authorize &&
                _this.authService.isAuthorized(item.meta.authorize));
        });
        // configuration menu items
        this.authorizedConfigurationMenuItems = this.routes.filter(function (item) {
            return (item.meta &&
                item.meta.includeInMenu &&
                item.meta.settings &&
                item.meta.authorize &&
                _this.authService.isAuthorized(item.meta.authorize));
        });
        this.searchTerm = '';
        this.onSearchTermChanged('', '');
        this.openSideNavigation();
    };
    TheSidebar.prototype.handleSidesheetClosed = function () {
        this.closeSideNavigation();
    };
    TheSidebar.prototype.onSearchTermChanged = function (val, oldVal) {
        var _this = this;
        if (val.length > 0) {
            this.menuItems = this.authorizedMenuItems.filter(function (item) {
                return _this.searchTerm.length > 0
                    ? item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
                    : true;
            });
            this.configurationMenuItems = this.authorizedConfigurationMenuItems.filter(function (item) {
                return _this.searchTerm.length > 0
                    ? item.name.toLowerCase().indexOf(val.toLowerCase()) > -1
                    : true;
            });
        }
        else {
            this.menuItems = this.authorizedMenuItems;
            this.configurationMenuItems = this.authorizedConfigurationMenuItems;
        }
    };
    var _a;
    __decorate([
        lazyInject(TYPES.AuthService),
        __metadata("design:type", typeof (_a = typeof AuthService !== "undefined" && AuthService) === "function" ? _a : Object)
    ], TheSidebar.prototype, "authService", void 0);
    __decorate([
        Watch('sideNavigationVisible', { immediate: false, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean, Boolean]),
        __metadata("design:returntype", void 0)
    ], TheSidebar.prototype, "onSideNavigationVisibleChanged", null);
    __decorate([
        Watch('searchTerm', { immediate: true, deep: false }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String]),
        __metadata("design:returntype", void 0)
    ], TheSidebar.prototype, "onSearchTermChanged", null);
    TheSidebar = __decorate([
        Component
    ], TheSidebar);
    return TheSidebar;
}(Mixins(LayoutMixin)));
export default TheSidebar;
